export default __webpack_public_path__ + "static/media/video yoga.b9ffe100.png";